
const resources = {
    fedexPickupLabel: 'FedEx Pickup Location',
    editLabel: 'Edit',
    useThisAddress: 'Use This Address'
};

export default function getResource(label) {
    return resources[label];
}
